module.exports = __webpack_public_path__ + "static/img/3.ee19638.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/3.png
// module id = iV+E
// module chunks = 0